import React, { useEffect, useState, useCallback } from 'react';
import { motion } from 'framer-motion';

const GamesPlagiarism = () => {
  const [gameStates, setGameStates] = useState({});
  const [gameCompletionStates, setGameCompletionStates] = useState({});

  const initializeGame = useCallback(async (gameId, hash) => {
    const container = document.getElementById(gameId);
    if (!container) return;
    setGameStates(prev => ({ ...prev, [gameId]: 'loading' }));
    container.innerHTML = '';
    
    const gameContainer = document.createElement('div');
    gameContainer.className = 'game-responsive-container';
    
    const updateStyle = () => {
      const isMobile = window.innerWidth < 768;
      const isCompleted = gameCompletionStates[gameId];
      if (isMobile) {
        gameContainer.style.cssText = `
          width: calc(100vw - 16px);
          height: ${isCompleted ? '85vh' : '80vh'};
          margin: 8px auto;
          padding: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f8fafc;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 16px rgba(0,0,0,0.08);
        `;
      } else {
        gameContainer.style.cssText = `
          width: 90%;
          height: ${isCompleted ? '80vh' : '75vh'};
          margin: 16px auto;
          padding: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f8fafc;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0,0,0,0.12);
        `;
      }
    };
    
    updateStyle();
    const iframe = document.createElement('iframe');
    iframe.src = `https://p.interacty.me/${hash}/iframe.html`;
    iframe.style.cssText = `width: 100%; height: 100%; border: none; scrolling: no;`;
    iframe.setAttribute('scrolling', 'no');
    
    iframe.onload = () => {
      setGameStates(prev => ({ ...prev, [gameId]: 'loaded' }));
      const applyScaling = () => {
        const isMobile = window.innerWidth < 768;
        const scale = isMobile ? 0.90 : 0.99;
        iframe.style.transform = `scale(${scale})`;
        iframe.style.width = `${(1 / scale) * 100}%`;
        iframe.style.height = `${(1 / scale) * 100}%`;
      };
      applyScaling();
      window.addEventListener('resize', applyScaling);
    };
    
    gameContainer.appendChild(iframe);
    container.appendChild(gameContainer);
  }, [gameCompletionStates]);

  useEffect(() => {
    const games = [
      { id: 'plagiarism-1', hash: '10419c583b87fe29' },
      { id: 'plagiarism-2', hash: 'd21ab0d7100927f9' },
      { id: 'plagiarism-3', hash: 'b84f70b9c6c08dac' }
    ];
    games.forEach(g => initializeGame(g.id, g.hash));
  }, [initializeGame]);

  const games = [
    { id: 'plagiarism-1', title: "🧟‍♂️ Parte # 1 🧟‍♀️", hash: "10419c583b87fe29" },
    { id: 'plagiarism-2', title: "🧟‍♂️ Parte # 2 🧟‍♀️", hash: "d21ab0d7100927f9" },
    { id: 'plagiarism-3', title: "🧟‍♂️ Parte # 3 🧟‍♀️", hash: "b84f70b9c6c08dac" }
  ];

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-7xl mx-auto px-4 py-8">
      <div className="text-center mb-8">
        <h1 className="text-3xl md:text-5xl font-bold bg-gradient-to-r from-red-500 to-orange-500 bg-clip-text text-transparent mb-4">
          Juegos - Plagio
        </h1>
        {/* AJUSTE SOLICITADO: Subtítulo añadido */}
        <p className="text-lg text-gray-600 dark:text-gray-300 mb-6">
          Aprende jugando sobre los tipos de plagio
        </p>

        {/* AJUSTE SOLICITADO: Recuadro de instrucciones */}
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6 mb-10 max-w-2xl mx-auto border border-indigo-100 dark:border-gray-700"
        >
          <div className="space-y-2 text-gray-700 dark:text-gray-200 font-medium leading-relaxed">
            <p className="text-xl font-bold text-indigo-600 dark:text-indigo-400 mb-4">¡Vamos a jugar! 🎯</p>
            <p>Busca dos (2) cartas iguales. 🎴🎴</p>
            <p>Primero, darás clic en iniciar. ▶️</p>
            <p>Luego, memorizarás las posiciones durante siete (7) segundos. 🧠 ⏰</p>
            <p>Encuentra todas las parejas para ganar. 🏆</p>
            <p>Aprende sobre los diversos tipos de plagio. 📖</p>
            <p className="text-lg font-bold text-purple-600 dark:text-purple-400 mt-4">¡Muchos éxitos! 🎉!</p>
          </div>
        </motion.div>
      </div>

      <div className="space-y-8">
        {games.map(game => (
          <div key={game.id} className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-4">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 dark:text-white mb-4 text-center">{game.title}</h2>
            <div id={game.id} className="game-container"></div>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default GamesPlagiarism;